"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeliveryRatio = void 0;
const useAccountData_1 = require("root/src/client/v2/userData/hooks/useAccountData");
function useDeliveryRatio() {
    const accountData = (0, useAccountData_1.useAccountData)();
    const { deliveryRatioNumerator = 0, deliveryRatioDenominator = 0 } = accountData || {};
    if (!deliveryRatioDenominator) {
        return 0;
    }
    return deliveryRatioNumerator / deliveryRatioDenominator;
}
exports.useDeliveryRatio = useDeliveryRatio;
